module.exports = __webpack_public_path__ + "static/media/calculator.2c92e5c8.svg";